import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  pages: []
}

// Store
export const pagesConfig = createSlice({
  name,
  initialState,
  reducers: {
    listPages: (state, { payload }) => {
      state.pages = payload || []
    },
    createPage: (state, { payload }) => {
      state.pages = [payload, ...state.pages]
    },
    updatePage: (state, { payload }) => {
      const index = state.pages.findIndex(page => page.pageId === payload.pageId)
      if (index !== -1) {
        state.pages[index] = { ...state.pages[index], ...payload }
      }
    },
    deletePage: (state, { payload }) => {
      const { pageId } = payload
      state.pages = state.pages.filter(page => page.pageId !== pageId)
    },
    reset: () => ({ ...initialState })
  }
})

export const {
  listPages,
  createPage,
  updatePage,
  deletePage,
  reset
} = pagesConfig.actions

export default pagesConfig.reducer
